<style scoped>
.banner-wrap {
  width: 100%;
}
.default-img {
  display: block;
  height: 500px;
}
.plus-img {
  height: 696px;
  width: 100%;
}
.small-img {
  height: 520px;
  width: 100%;
}
.no-banner {
  display: none;
}
</style>

<template>
  <div
    class="banner-wrap"
    :class="{'no-banner': noBanner}"
    :style="'background-color: '+ bgfill +';'"
  >
    <div>
      <div
        :class="{'default-img': true, 'small-img': imgSize == 'small',
            'plus-img': imgSize == 'plus'}"
        :style="'background:url(' + imgUrl + ') no-repeat center center;'"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "banner_wrap",
  props: {
    imgUrl: {
      type: String,
      required: false
    },
    imgSize: {
      type: String,
      default: ""
    },
    noBanner: {
      type: Boolean,
      default: false
    },
    bgfill: {
      type: String,
      required: false
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/page/common/Banner.vue